<template>
  <div class="columns">
    <template v-if="actionItems.length > 0">
      <div class="column">
        <List
          :items="actionItems"
          :title="actionTitle"
          @input="handleInput"
        />
      </div>
    </template>
    <template v-if="fieldItems.length > 0">
      <div class="column">
        <List
          :items="fieldItems"
          :title="fieldTitle"
          @input="handleInput"
        />
      </div>
    </template>
    <template v-if="interfaceItems.length > 0">
      <div class="column">
        <List
          :items="interfaceItems"
          :title="interfaceTitle"
          @input="handleInput"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Model from "../ModuleAttrModel.js";

import List from "./MattReI_Section_List.vue";

export default {
  components: {
    List
  },
  props: {
    moduleAttrList: Array,
    moduleId: Number,
    subCode: String
  },
  data: () => ({
    actionItems: [],
    fieldItems: [],
    interfaceItems: []
  }),
  computed: {
    actionTitle() {
      return Model.Type.Action.Label;
    },
    fieldTitle() {
      return Model.Type.Field.Label;
    },
    interfaceTitle() {
      return Model.Type.Interface;
    },
    title() {
      return Model.ModuleType.List.Name + " " + Model.Module.FullName;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.actionItems = [];
      this.fieldItems = [];
      this.interfaceItems = [];
      this.buttonsVisible = false;

      for (const moduleAttr of this.moduleAttrList) {
        if (moduleAttr.ModuleID === this.moduleId) {
          // validation
          if (moduleAttr.SubCode !== this.subCode) {
            continue;
          }

          if (moduleAttr.TypeID === Model.Type.Action.ID) {
            this.actionItems.push(moduleAttr);

            // if: set buttons visibility (must have module attr other than default)
            // currently only for action
            if (!moduleAttr.IsDefault) {
              this.buttonsVisible = true;
            }
          }
          else if (moduleAttr.TypeID === Model.Type.Field.ID) {
            this.fieldItems.push(moduleAttr);
          }
          else if (moduleAttr.TypeID === Model.Type.Section.ID ||
            moduleAttr.TypeID === Model.Type.Tab.ID
          ) {
            this.interfaceItems.push(moduleAttr);
          }
          // else: unknown (skip)
        }
      }
    },
    handleInput(item) {
      this.$emit(this.$kst.Enum.Event.Input, item);
    }
  }
}
</script>